import type { ErrorEvent } from '@sentry/react'

/**
 * Erros que não vêm do nosso código: script injetado por extensão de navegador
 * ou pelo próprio documento HTML. O sinal é o stacktrace não conter nenhum
 * frame do bundle.
 */
export function isNoiseEvent(event: Partial<ErrorEvent>): boolean {
  const frames = event.exception?.values?.flatMap((value) => value.stacktrace?.frames ?? []) ?? []
  if (frames.length === 0) return false

  return !frames.some((frame) => {
    const filename = frame.filename ?? ''
    if (filename.includes('-extension://')) return false
    return /\.[cm]?js(\?|$)/.test(filename)
  })
}
